const ProcessingStep = ({ photo }) => (
    <div className="flex flex-col items-center py-10">
        {photo && (
            <div className="w-[68px] h-[68px] rounded-full overflow-hidden border-2 border-[#E8E6E3] mb-6 shrink-0">
                <img src={photo} alt="" className="w-full h-full object-cover object-top" />
            </div>
        )}
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#38433A] mb-4" />
        <p className="text-[15px] text-[#2D2D2D] text-center mb-1">Analyzing smile...</p>
        <p className="text-[13px] text-[#939393] text-center">Generating your AI preview</p>
    </div>
);

export default ProcessingStep;
